// Imagina Ser: caja "Crea tu cuento". Arma el pedido, achica las fotos en el navegador y lo envía a la API.
(() => {
  const MAX_PERSONAJES = 4;
  const LADO_MAX = 1600;
  const TIPOS = [["nino", "Niño"], ["nina", "Niña"], ["persona", "Adulto"], ["mascota", "Mascota"]];

  function iniciar(raiz) {
    if (raiz.dataset.listo) return;
    raiz.dataset.listo = "1";
    const $ = (sel) => raiz.querySelector(`[data-is="${sel}"]`);
    const api = raiz.dataset.api.replace(/\/$/, "");
    const estado = { personajes: [nuevoPersonaje()], lugar: { descripcion: "", foto: null }, estilo: "realismo", nombreEstilo: "Realismo ilustrado" };

    function nuevoPersonaje() {
      return { nombre: "", tipo: "nino", edad: "", descripcion: "", foto: null, sinFoto: false };
    }

    // --- Ventanas ---
    const abrir = (dlg) => { dlg.showModal(); };
    raiz.querySelectorAll("dialog").forEach((dlg) => {
      dlg.addEventListener("click", (e) => { if (e.target === dlg) dlg.close(); });
      dlg.querySelectorAll('[data-is="cerrar"]').forEach((b) => b.addEventListener("click", () => dlg.close()));
      dlg.addEventListener("close", resumir);
    });
    $("abrir-personajes").addEventListener("click", () => { pintarPersonajes(); abrir($("dlg-personajes")); });
    $("abrir-lugar").addEventListener("click", () => abrir($("dlg-lugar")));
    $("abrir-estilo").addEventListener("click", () => abrir($("dlg-estilo")));

    // --- Personajes ---
    function pintarPersonajes() {
      const lista = $("lista-personajes");
      lista.innerHTML = "";
      estado.personajes.forEach((p, i) => {
        const tarjeta = document.createElement("div");
        tarjeta.className = "is-personaje";
        tarjeta.innerHTML = `
          <div class="is-personaje-fila">
            <label class="is-foto" data-con="${p.foto ? 1 : 0}"><span>📷</span><span>Agregar foto</span><input type="file" accept="image/*" aria-label="Foto del personaje ${i + 1}"></label>
            <div>
              <input class="is-campo" data-c="nombre" maxlength="40" placeholder="Nombre del personaje ${i + 1}" aria-label="Nombre">
              <div class="is-tipos" role="group" aria-label="Tipo">${TIPOS.map(([v, t]) => `<button type="button" data-tipo="${v}" aria-pressed="${p.tipo === v}">${t}</button>`).join("")}</div>
              <div class="is-mini"><input class="is-campo" data-c="edad" type="number" min="0" max="110" inputmode="numeric" placeholder="Edad" aria-label="Edad" style="max-width:110px"></div>
            </div>
          </div>
          <button type="button" class="is-enlace" data-c="alternar">${p.sinFoto || p.descripcion ? "Ocultar descripción" : "¿Sin foto? Descríbelo con palabras"}</button>
          <textarea class="is-campo ${p.sinFoto || p.descripcion ? "" : "is-oculto"}" data-c="descripcion" rows="2" maxlength="200" placeholder="Pelo café ondulado, ojos verdes, lentes redondos, le encanta su polerón de dinosaurio" style="margin-top:8px"></textarea>
          ${estado.personajes.length > 1 ? '<button type="button" class="is-quitar" data-c="quitar">Quitar personaje</button>' : ""}`;
        const foto = tarjeta.querySelector(".is-foto");
        if (p.foto) foto.style.backgroundImage = `url(${p.foto.vista})`;
        const nombre = tarjeta.querySelector('[data-c="nombre"]');
        nombre.value = p.nombre;
        nombre.addEventListener("input", () => { p.nombre = nombre.value; });
        const edad = tarjeta.querySelector('[data-c="edad"]');
        edad.value = p.edad;
        edad.addEventListener("input", () => { p.edad = edad.value; });
        const desc = tarjeta.querySelector('[data-c="descripcion"]');
        desc.value = p.descripcion;
        desc.addEventListener("input", () => { p.descripcion = desc.value; });
        tarjeta.querySelector('[data-c="alternar"]').addEventListener("click", (e) => {
          p.sinFoto = desc.classList.toggle("is-oculto") === false;
          e.target.textContent = p.sinFoto ? "Ocultar descripción" : "¿Sin foto? Descríbelo con palabras";
          if (p.sinFoto) desc.focus();
        });
        tarjeta.querySelectorAll("[data-tipo]").forEach((b) => b.addEventListener("click", () => {
          p.tipo = b.dataset.tipo;
          tarjeta.querySelectorAll("[data-tipo]").forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
        }));
        foto.querySelector("input").addEventListener("change", async (e) => {
          const archivo = e.target.files[0];
          if (!archivo) return;
          try {
            p.foto = await prepararFoto(archivo);
            foto.style.backgroundImage = `url(${p.foto.vista})`;
            foto.dataset.con = "1";
          } catch {
            mostrarError("No pudimos leer esa foto. Prueba con otra (JPG o PNG).");
          }
        });
        tarjeta.querySelector('[data-c="quitar"]')?.addEventListener("click", () => {
          estado.personajes.splice(i, 1);
          pintarPersonajes();
        });
        lista.appendChild(tarjeta);
      });
      $("agregar-personaje").classList.toggle("is-oculto", estado.personajes.length >= MAX_PERSONAJES);
    }
    $("agregar-personaje").addEventListener("click", () => {
      if (estado.personajes.length >= MAX_PERSONAJES) return;
      estado.personajes.push(nuevoPersonaje());
      pintarPersonajes();
    });

    // --- Lugar ---
    const fotoLugar = $("foto-lugar");
    $("input-lugar").addEventListener("change", async (e) => {
      const archivo = e.target.files[0];
      if (!archivo) return;
      try {
        estado.lugar.foto = await prepararFoto(archivo);
        fotoLugar.style.backgroundImage = `url(${estado.lugar.foto.vista})`;
        fotoLugar.dataset.con = "1";
        $("quitar-lugar").classList.remove("is-oculto");
      } catch {
        mostrarError("No pudimos leer esa foto. Prueba con otra (JPG o PNG).");
      }
    });
    $("quitar-lugar").addEventListener("click", () => {
      estado.lugar.foto = null;
      fotoLugar.style.backgroundImage = "";
      fotoLugar.dataset.con = "0";
      $("input-lugar").value = "";
      $("quitar-lugar").classList.add("is-oculto");
    });
    $("lugar-desc").addEventListener("input", (e) => { estado.lugar.descripcion = e.target.value; });

    // --- Estilo ---
    raiz.querySelectorAll('[data-is="estilo"]').forEach((b) => b.addEventListener("click", () => {
      estado.estilo = b.dataset.clave;
      estado.nombreEstilo = b.dataset.nombre;
      raiz.querySelectorAll('[data-is="estilo"]').forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
    }));

    function resumir() {
      const listos = estado.personajes.filter((p) => p.nombre.trim());
      $("txt-personajes").textContent = listos.length ? listos.map((p) => p.nombre.trim()).join(", ") : "Personajes";
      $("abrir-personajes").dataset.lleno = listos.length ? "1" : "0";
      const hayLugar = estado.lugar.foto || estado.lugar.descripcion.trim();
      $("txt-lugar").textContent = hayLugar ? (estado.lugar.descripcion.trim().slice(0, 28) || "Foto del lugar") : "Lugar";
      $("abrir-lugar").dataset.lleno = hayLugar ? "1" : "0";
      $("txt-estilo").textContent = estado.nombreEstilo;
    }

    // --- Enviar ---
    function mostrarError(texto) {
      const e = $("error");
      e.textContent = texto;
      e.classList.toggle("is-oculto", !texto);
    }

    $("form").addEventListener("submit", async (ev) => {
      ev.preventDefault();
      mostrarError("");
      const idea = $("idea").value.trim();
      const personajes = estado.personajes.filter((p) => p.nombre.trim() || p.foto);
      if (idea.length < 10) return mostrarError("Cuéntanos un poco más de la historia que imaginas.");
      if (!personajes.length) {
        mostrarError("Agrega al menos un personaje (con su nombre).");
        return $("abrir-personajes").click();
      }
      if (personajes.some((p) => !p.nombre.trim())) {
        mostrarError("Cada personaje necesita un nombre.");
        return $("abrir-personajes").click();
      }
      const hayFotos = personajes.some((p) => p.foto) || estado.lugar.foto;
      if (hayFotos && !$("consentimiento").checked) return mostrarError("Para usar las fotos necesitamos tu autorización (marca la casilla).");
      const email = $("email").value.trim();
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return mostrarError("Revisa tu correo.");

      const boton = $("crear");
      boton.disabled = true;
      boton.textContent = "Pensando en tu cuento…";
      const resumenPersonajes = personajes.map((p) => ({ nombre: p.nombre.trim(), tipo: p.tipo, edad: p.edad, descripcion: p.descripcion.trim() }));
      const detalles = await preguntarMas(idea, resumenPersonajes);
      if (detalles === null) {
        boton.disabled = false;
        boton.textContent = "✨ Crear vista previa gratis";
        return;
      }

      const datos = {
        idea: detalles ? `${idea}\n\nMás detalles de la familia:\n${detalles}` : idea,
        estilo: estado.estilo,
        email,
        personajes: personajes.map((p) => ({ nombre: p.nombre.trim(), tipo: p.tipo, edad: p.edad, descripcion: p.descripcion.trim() })),
        lugar: { descripcion: estado.lugar.descripcion.trim() }
      };
      const form = new FormData();
      form.append("datos", JSON.stringify(datos));
      personajes.forEach((p, i) => { if (p.foto) form.append(`foto_${i}`, p.foto.blob, `personaje-${i}.jpg`); });
      if (estado.lugar.foto) form.append("lugar", estado.lugar.foto.blob, "lugar.jpg");

      boton.textContent = "Enviando tu cuento…";
      try {
        const r = await fetch(`${api}/api/cuentos`, { method: "POST", body: form });
        const d = await r.json().catch(() => ({}));
        if (!r.ok || !d.id) throw new Error(d.error || "No pudimos crear tu cuento. Inténtalo de nuevo en un momento.");
        guardarCuento(d.id);
        const destino = new URL(raiz.dataset.paginaCuento || "/pages/mi-cuento", location.origin);
        destino.searchParams.set("id", d.id);
        location.href = destino.toString();
      } catch (e) {
        mostrarError(e.message || "No pudimos conectarnos. Revisa tu internet e inténtalo de nuevo.");
        boton.disabled = false;
        boton.textContent = "✨ Crear vista previa gratis";
      }
    });

    // La IA hace 2 o 3 preguntas para enriquecer la idea. Devuelve las respuestas como texto,
    // "" si no hay preguntas o la familia las salta, y null si cierra la ventana (cancela).
    async function preguntarMas(idea, personajes) {
      let preguntas = [];
      try {
        const r = await fetch(`${api}/api/preguntas`, {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify({ idea, personajes })
        });
        preguntas = (await r.json()).preguntas || [];
      } catch { /* sin preguntas: se sigue igual */ }
      if (!preguntas.length) return "";
      const dlg = $("dlg-preguntas");
      const lista = $("lista-preguntas");
      lista.innerHTML = "";
      preguntas.forEach((q, i) => {
        const id = `${raiz.id}-q${i}`;
        const bloque = document.createElement("div");
        bloque.innerHTML = `<label class="is-etiqueta" for="${id}"></label><input class="is-campo" id="${id}" maxlength="200">`;
        bloque.querySelector("label").textContent = q.pregunta;
        bloque.querySelector("input").placeholder = q.ejemplo ? `Ej.: ${q.ejemplo}` : "";
        lista.appendChild(bloque);
      });
      return new Promise((ok) => {
        let resultado = null;
        const cerrar = (valor) => { resultado = valor; dlg.close(); };
        $("seguir-preguntas").onclick = () => cerrar(preguntas
          .map((q, i) => [q.pregunta, lista.querySelectorAll("input")[i].value.trim()])
          .filter(([, r]) => r)
          .map(([q, r]) => `- ${q} ${r}`)
          .join("\n"));
        $("saltar-preguntas").onclick = () => cerrar("");
        dlg.addEventListener("close", () => ok(resultado), { once: true });
        dlg.showModal();
        lista.querySelector("input")?.focus();
      });
    }

    resumir();
  }

  // Achica la foto (máx. 1600 px), la pasa a JPEG y de paso le quita los metadatos (GPS, etc.).
  async function prepararFoto(archivo) {
    const bitmap = await createImageBitmap(archivo, { imageOrientation: "from-image" });
    const escala = Math.min(1, LADO_MAX / Math.max(bitmap.width, bitmap.height));
    const lienzo = document.createElement("canvas");
    lienzo.width = Math.round(bitmap.width * escala);
    lienzo.height = Math.round(bitmap.height * escala);
    lienzo.getContext("2d").drawImage(bitmap, 0, 0, lienzo.width, lienzo.height);
    bitmap.close?.();
    const blob = await new Promise((ok, mal) => lienzo.toBlob((b) => (b ? ok(b) : mal(new Error("sin imagen"))), "image/jpeg", 0.88));
    return { blob, vista: URL.createObjectURL(blob) };
  }

  function guardarCuento(id) {
    try {
      const lista = JSON.parse(localStorage.getItem("imaginaser-cuentos") || "[]").filter((x) => x !== id);
      lista.unshift(id);
      localStorage.setItem("imaginaser-cuentos", JSON.stringify(lista.slice(0, 20)));
    } catch { /* sin almacenamiento local: no pasa nada */ }
  }

  const todos = () => document.querySelectorAll('[id^="is-creador-"]').forEach(iniciar);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", todos);
  else todos();
  document.addEventListener("shopify:section:load", todos);
})();
